export default __webpack_public_path__ + "static/media/P330_CoC.cb7e616b.pdf";